(function () {
  var fsbRefreshTimer = null;
  var fsbRefreshInFlight = false;
  var agreementSyncInFlight = false;
  var deliveryAreaSyncInFlight = false;
  var expressAreaSyncInFlight = false;
  var expressWindowSyncInFlight = false;
  var expressThresholdSyncInFlight = false;
  var checkoutTotalObserver = null;
  var checkoutStateObserver = null;
  var checkoutSyncTimers = [];
  var latestCartState = null;
  var latestZapietCheckoutParams = null;
  var latestZapietAreaState = null;
  var zapietCheckoutReady = false;
  var zapietEventBridgeInstalled = false;
  var zapietSelectionStarted = false;
  var checkoutStateSyncQueued = false;

  function postForm(url, params, onDone, onError) {
    var body = new URLSearchParams();
    Object.keys(params).forEach(function (key) {
      body.append(key, params[key]);
    });

    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        Accept: 'application/json',
      },
      body: body.toString(),
      credentials: 'same-origin',
    })
      .then(function (res) {
        if (!res.ok) {
          throw new Error('Request failed: ' + res.status);
        }

        return res.json().catch(function () {
          return {};
        });
      })
      .then(function (data) {
        if (onDone) onDone(data);
      })
      .catch(function (error) {
        if (onError) onError(error);
      });
  }

  function isAgreementRequired(cart) {
    return hasShippingRequiredItems(cart);
  }

  function isAgreementValid(cart) {
    if (!isAgreementRequired(cart)) return true;

    var checkboxes = Array.prototype.slice.call(document.querySelectorAll('[data-cart-agreement]'));
    if (!checkboxes.length) return true;

    return checkboxes.every(function (checkbox) {
      return checkbox.checked;
    });
  }

  function getAgreementCheckboxes() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-cart-agreement]'));
  }

  function getAgreementAttributeInputs() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-cart-agreement-attribute-input]'));
  }

  function getAgreementAttributeValue(cart) {
    return String(getCartAttributeValue(cart, 'Cart Agreement') || '')
      .trim()
      .toLowerCase() === 'true';
  }

  function updateAgreementAttributeInputs(value) {
    var nextValue = value ? 'True' : '';

    getAgreementAttributeInputs().forEach(function (input) {
      input.value = nextValue;
    });
  }

  function syncAgreementCheckboxStateFromCart(cart) {
    var confirmed = isAgreementRequired(cart) && getAgreementAttributeValue(cart);
    var checkboxes = getAgreementCheckboxes();
    if (!checkboxes.length) return;

    checkboxes.forEach(function (checkbox) {
      checkbox.checked = confirmed;
    });

    updateAgreementAttributeInputs(confirmed);
  }

  function syncCartAgreementAttribute(value, onDone) {
    if (agreementSyncInFlight) return;

    agreementSyncInFlight = true;
    applyCheckoutState();
    updateAgreementAttributeInputs(value);

    postForm(
      '/cart/update.js',
      {
        'attributes[Cart Agreement]': value ? 'True' : '',
      },
      function (cart) {
        agreementSyncInFlight = false;
        if (cart && typeof cart === 'object') {
          latestCartState = cart;
        }
        if (onDone) onDone(cart);
        applyCheckoutState(cart);
      },
      function () {
        agreementSyncInFlight = false;
        if (onDone) onDone(getEffectiveCart());
        applyCheckoutState();
      }
    );
  }

  function syncAgreementAttributeIfNeeded(cart) {
    var checkboxes = getAgreementCheckboxes();
    if (!checkboxes.length) return;

    if (!isAgreementRequired(cart)) {
      updateAgreementAttributeInputs(false);

      if (getAgreementAttributeValue(cart) && !agreementSyncInFlight) {
        syncCartAgreementAttribute(false);
      }

      return;
    }

    var confirmed = isAgreementValid(cart);
    var saved = getAgreementAttributeValue(cart);

    updateAgreementAttributeInputs(confirmed);

    if (confirmed === saved || agreementSyncInFlight) return;

    syncCartAgreementAttribute(confirmed, function (nextCart) {
      syncAgreementCheckboxStateFromCart(nextCart || cart);
    });
  }

  function isZapietCartWidgetActive() {
    return !!document.querySelector('#storePickupApp, #zapiet-checkout-methods, .zapiet-widget-wrapper');
  }

  function shouldDeferCheckoutEnableToZapiet(checkoutBtn) {
    return (
      !!checkoutBtn &&
      checkoutBtn.hasAttribute('data-zapiet-checkout-button') &&
      !window.seExpressInCart &&
      isZapietCartWidgetActive()
    );
  }

  function isZapietOwnedCheckoutTrigger(checkoutBtn) {
    return shouldDeferCheckoutEnableToZapiet(checkoutBtn);
  }

  function isFreeGiftSyncPending() {
    return (
      window.SteakKingFreeGiftPromotions &&
      typeof window.SteakKingFreeGiftPromotions.isSyncPending === 'function' &&
      window.SteakKingFreeGiftPromotions.isSyncPending()
    );
  }

  function isCheckoutAllowed(cart) {
    return (
      isAgreementValid(cart) &&
      isDeliveryAreaValid(cart) &&
      isMinimumOrderMet(cart) &&
      isZapietSelectionComplete(cart) &&
      !isCartSyncPending()
    );
  }

  function applyCheckoutState(cart) {
    var checkoutBtn = document.querySelector('button[name="checkout"], input[name="checkout"]');
    if (!checkoutBtn) return;
    var checkoutAllowed = isCheckoutAllowed(cart);

    if (checkoutAllowed) {
      delete checkoutBtn.dataset.seCheckoutGuardDisabled;

      if (shouldDeferCheckoutEnableToZapiet(checkoutBtn)) {
        syncCheckoutButtonToSummary();
        return;
      }

      checkoutBtn.removeAttribute('disabled');
      updateZapietMethodMessage(cart, false);
      syncCheckoutButtonToSummary();
      return;
    }

    checkoutBtn.dataset.seCheckoutGuardDisabled = 'true';
    checkoutBtn.setAttribute('disabled', 'disabled');
    updateZapietMethodMessage(cart, true);
    syncCheckoutButtonToSummary();
  }

  function queueCheckoutStateSync(cart) {
    if (checkoutStateSyncQueued) return;
    checkoutStateSyncQueued = true;

    window.requestAnimationFrame(function () {
      checkoutStateSyncQueued = false;
      applyCheckoutState(cart);
    });
  }

  function initCheckoutStateObserver() {
    var checkoutArea = document.querySelector('.cart__footer__checkout');
    if (!checkoutArea) return;

    if (checkoutStateObserver) {
      checkoutStateObserver.disconnect();
    }

    checkoutStateObserver = new MutationObserver(function () {
      queueCheckoutStateSync();
    });

    checkoutStateObserver.observe(checkoutArea, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['disabled', 'class', 'style', 'data-zapiet-checkout-button'],
    });
  }

  function isCartSyncPending() {
    return (
      agreementSyncInFlight ||
      deliveryAreaSyncInFlight ||
      expressAreaSyncInFlight ||
      expressWindowSyncInFlight ||
      expressThresholdSyncInFlight ||
      isFreeGiftSyncPending()
    );
  }

  function unlockZapietIfExpress() {
    if (!window.seExpressInCart) return;

    ['#storePickupApp', '#zapiet-checkout-methods', '.zapiet-widget-wrapper'].forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (el) {
        el.style.display = 'none';
      });
    });

    var checkoutBtn = document.querySelector('button[name="checkout"], input[name="checkout"]');
    if (!checkoutBtn || !checkoutBtn.parentNode) return;

    if (!checkoutBtn.hasAttribute('data-zapiet-checkout-button')) {
      applyCheckoutState();
      return;
    }

    var clone = checkoutBtn.cloneNode(true);
    clone.removeAttribute('data-zapiet-checkout-button');

    if (checkoutBtn.id) {
      clone.id = checkoutBtn.id;
    }

    clone.disabled = checkoutBtn.disabled;
    checkoutBtn.parentNode.replaceChild(clone, checkoutBtn);
    applyCheckoutState();
  }

  function applyCartSavingsState(hasSavings) {
    document.querySelectorAll('.cart__template').forEach(function (template) {
      template.classList.toggle('cart--has-savings', hasSavings);
      template.classList.toggle('cart--no-savings', !hasSavings);
    });
  }

  function readCartSavingsStateFromDom() {
    return !!document.querySelector('[data-line-items] .cart__items__row .cart__items__saving-col');
  }

  function syncCartSavingsState() {
    applyCartSavingsState(readCartSavingsStateFromDom());

    setTimeout(function () {
      applyCartSavingsState(readCartSavingsStateFromDom());
    }, 180);
  }

  function initFreeshippingBars() {
    if (typeof HCFsb === 'undefined') return;

    document.querySelectorAll('[data-hc-fsb]').forEach(function (container) {
      if (!container.id) return;
      if (container.dataset.fsbInit === '1') return;

      container.dataset.fsbInit = '1';

      try {
        var instance = new HCFsb({
          selector: '#' + container.id,
          events: ['fsb:cart:update'],
          placeholder: '(x)',
        });

        instance.update();
      } catch (error) {
        console.error(error);
      }
    });
  }

  function initFsbAddonsCarousels() {
    document.querySelectorAll('[data-hc-fsb-addons-carousel]').forEach(function (carousel) {
      var grid = carousel.querySelector('[data-hc-fsb-addons-grid]');
      if (!grid) return;
      if (grid.dataset.fsbCarouselInit === '1') return;

      var cells = Array.prototype.slice.call(grid.querySelectorAll('.addon-grid__item'));
      var prevBtn = carousel.querySelector('[data-hc-fsb-prev]');
      var nextBtn = carousel.querySelector('[data-hc-fsb-next]');

      if (!cells.length || cells.length <= 1) {
        if (prevBtn) prevBtn.style.display = 'none';
        if (nextBtn) nextBtn.style.display = 'none';
        grid.dataset.fsbCarouselInit = '1';
        return;
      }

      var index = 0;
      var maxIndex = Math.max(cells.length - 1, 0);

      function clamp(nextIndex) {
        if (nextIndex < 0) return 0;
        if (nextIndex > maxIndex) return maxIndex;
        return nextIndex;
      }

      function setArrowState() {
        if (prevBtn) {
          if (index <= 0) {
            prevBtn.setAttribute('disabled', 'disabled');
          } else {
            prevBtn.removeAttribute('disabled');
          }
        }

        if (nextBtn) {
          if (index >= maxIndex) {
            nextBtn.setAttribute('disabled', 'disabled');
          } else {
            nextBtn.removeAttribute('disabled');
          }
        }
      }

      function goTo(nextIndex, smooth) {
        index = clamp(nextIndex);
        cells.forEach(function (cell, cellIndex) {
          if (cellIndex === index) {
            cell.classList.add('is-active');
            cell.removeAttribute('hidden');
          } else {
            cell.classList.remove('is-active');
            cell.setAttribute('hidden', 'hidden');
          }
        });
        setArrowState();
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function (event) {
          event.preventDefault();
          goTo(index - 1, true);
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function (event) {
          event.preventDefault();
          goTo(index + 1, true);
        });
      }

      grid.dataset.fsbCarouselInit = '1';
      goTo(0, false);
    });
  }

  function initFsbAddonQtySteppers() {
    if (document.body.dataset.fsbQtyInit === '1') return;
    document.body.dataset.fsbQtyInit = '1';

    document.addEventListener('click', function (event) {
      var btn = event.target && event.target.closest('[data-fsb-qty-increase], [data-fsb-qty-decrease]');
      if (!btn) return;

      var wrapper = btn.closest('[data-fsb-qty-selector]');
      if (!wrapper) return;

      var input = wrapper.querySelector('[data-fsb-qty-input]');
      if (!input) return;

      var min = parseInt(input.getAttribute('min') || '1', 10);
      var value = parseInt(input.value || '1', 10);
      if (isNaN(value)) value = min;

      if (btn.hasAttribute('data-fsb-qty-increase')) {
        value += 1;
      } else {
        value -= 1;
      }

      if (value < min) value = min;
      input.value = String(value);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  function refreshFreeshippingSection() {
    var currentBars = Array.prototype.slice.call(document.querySelectorAll('[data-hc-fsb]'));
    if (!currentBars.length || fsbRefreshInFlight) return;

    fsbRefreshInFlight = true;

    fetch(window.location.pathname + window.location.search, {
      credentials: 'same-origin',
      headers: {
        Accept: 'text/html',
      },
    })
      .then(function (res) {
        if (!res.ok) {
          throw new Error('FSB refresh failed: ' + res.status);
        }

        return res.text();
      })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');

        currentBars.forEach(function (currentBar) {
          if (!currentBar.id || !currentBar.parentNode) return;

          var freshBar = doc.getElementById(currentBar.id);
          if (!freshBar) return;

          currentBar.parentNode.replaceChild(freshBar, currentBar);
        });
      })
      .catch(function (error) {
        console.error(error);
      })
      .finally(function () {
        fsbRefreshInFlight = false;
        initFreeshippingBars();
        initFsbAddonsCarousels();
      });
  }

  function addToCart(id, qty, onDone, onError) {
    postForm('/cart/add.js', { id: String(id), quantity: String(qty) }, onDone, onError);
  }

  function setVariantQty(id, qty, onDone, onError) {
    var key = 'updates[' + String(id) + ']';
    var params = {};
    params[key] = String(qty);
    postForm('/cart/update.js', params, onDone, onError);
  }

  // COMPONENT: Cart total sync — keeps the checkout CTA amount aligned with the live AJAX cart payload instead of stale server-rendered text.
  function formatCartMoney(cents) {
    if (typeof cents !== 'number') return '';

    try {
      var price = themeCurrency.formatMoney(cents, theme.moneyFormat);
      return theme.currencyCode ? price + ' ' + theme.currencyCode : price;
    } catch (error) {
      return '';
    }
  }

  function updateCheckoutButtonAmount(cart) {
    if (!cart || typeof cart.total_price !== 'number') return;

    var checkoutBtn = document.querySelector('button[name="checkout"], input[name="checkout"]');
    if (!checkoutBtn) return;

    var label =
      checkoutBtn.getAttribute('data-checkout-label') ||
      (checkoutBtn.value || checkoutBtn.textContent || '').split(' - ')[0].trim();
    var formattedTotal = formatCartMoney(cart.total_price);
    if (!formattedTotal || !label) return;

    if (checkoutBtn.tagName === 'INPUT') {
      checkoutBtn.value = label + ' - ' + formattedTotal;
      return;
    }

    checkoutBtn.textContent = label + ' - ' + formattedTotal;
  }

  function updateCheckoutButtonDisplay(amountText) {
    if (!amountText) return;

    var checkoutBtn = document.querySelector('button[name="checkout"], input[name="checkout"]');
    if (!checkoutBtn) return;

    var label =
      checkoutBtn.getAttribute('data-checkout-label') ||
      (checkoutBtn.value || checkoutBtn.textContent || '').split(' - ')[0].trim();
    if (!label) return;

    var nextValue = label + ' - ' + amountText;

    if (checkoutBtn.tagName === 'INPUT') {
      checkoutBtn.value = nextValue;
      return;
    }

    checkoutBtn.textContent = nextValue;
  }

  // COMPONENT: Checkout amount mirror — the summary total is the cart UI source of truth after AJAX quantity refreshes, so the CTA mirrors that settled number.
  function syncCheckoutButtonToSummary() {
    var summaryTotal = document.querySelector('[data-cart-final]');
    if (!summaryTotal) return;

    var amountText = (summaryTotal.textContent || '').replace(/\s+/g, ' ').trim();
    if (!amountText) return;

    updateCheckoutButtonDisplay(amountText);
  }

  function initCheckoutTotalObserver() {
    var summaryTotal = document.querySelector('[data-cart-final]');
    if (!summaryTotal) return;

    if (checkoutTotalObserver) {
      checkoutTotalObserver.disconnect();
    }

    checkoutTotalObserver = new MutationObserver(function () {
      syncCheckoutButtonToSummary();
    });

    checkoutTotalObserver.observe(summaryTotal, {
      childList: true,
      characterData: true,
      subtree: true,
    });
  }

  function clearCheckoutSyncTimers() {
    checkoutSyncTimers.forEach(function (timerId) {
      window.clearTimeout(timerId);
    });
    checkoutSyncTimers = [];
  }

  // PERF: Quantity changes update the summary asynchronously, so the CTA is re-synced over a short settling window to prevent stale totals from flashing to customers.
  function scheduleCheckoutButtonSync() {
    clearCheckoutSyncTimers();

    [0, 120, 280, 520, 900, 1400].forEach(function (delay) {
      checkoutSyncTimers.push(
        window.setTimeout(function () {
          syncCheckoutButtonToSummary();
        }, delay)
      );
    });
  }

  function getCartItems(cart) {
    return cart && Array.isArray(cart.items) ? cart.items : [];
  }

  function getCartAttributes(cart) {
    return cart && cart.attributes ? cart.attributes : {};
  }

  function getEffectiveCart(cart) {
    return cart || latestCartState;
  }

  function normalizeDeliveryArea(value) {
    var text = String(value || '')
      .toLowerCase()
      .replace(/\s+/g, ' ')
      .trim();

    if (!text) return '';
    if (text.indexOf('hong kong island') !== -1 || text.indexOf('hk island') !== -1) return 'hk_island';
    if (text.indexOf('new territories') !== -1) return 'new_territories';
    if (text.indexOf('kowloon') !== -1) return 'kowloon';
    return '';
  }

  function getCartAttributeValue(cart, key) {
    var attrs = getCartAttributes(cart);
    var matchedValue = '';

    Object.keys(attrs).some(function (attrKey) {
      if (String(attrKey).toLowerCase() !== String(key).toLowerCase()) return false;
      matchedValue = attrs[attrKey];
      return true;
    });

    return matchedValue;
  }

  function hasOwn(object, key) {
    return !!object && Object.prototype.hasOwnProperty.call(object, key);
  }

  function getMergedStateValue(nextState, baseState, key) {
    if (hasOwn(nextState, key)) {
      return nextState[key];
    }

    return baseState[key];
  }

  function getTrimmedString(value) {
    return String(value == null ? '' : value).replace(/\s+/g, ' ').trim();
  }

  function normalizeZapietAreaCode(value) {
    return getTrimmedString(value).replace(/-E$/, '');
  }

  function getEnglishAreaNameFromCode(areaCode, district) {
    var normalizedCode = normalizeZapietAreaCode(areaCode);
    var normalizedDistrict = getTrimmedString(district);

    if (!normalizedCode || !window.HK_DISTRICT_DATA) return '';

    function findAreaName(districtName) {
      var areas = window.HK_DISTRICT_DATA[districtName];
      if (!areas || !areas.length) return '';

      for (var index = 0; index < areas.length; index += 1) {
        var area = areas[index];
        if (!area || getTrimmedString(area.code) !== normalizedCode) continue;
        return getTrimmedString(area.english);
      }

      return '';
    }

    if (normalizedDistrict) {
      var districtMatch = findAreaName(normalizedDistrict);
      if (districtMatch) return districtMatch;
    }

    var districts = Object.keys(window.HK_DISTRICT_DATA);
    for (var districtIndex = 0; districtIndex < districts.length; districtIndex += 1) {
      var areaName = findAreaName(districts[districtIndex]);
      if (areaName) return areaName;
    }

    return '';
  }

  function buildZapietAreaState(state) {
    state = state || {};

    var district = getTrimmedString(state.district || state.deliveryArea);
    var deliveryArea = getTrimmedString(state.deliveryArea || district);
    var area = getTrimmedString(state.area || getEnglishAreaNameFromCode(state.areaCode || state.code, district));
    var areaCode = getTrimmedString(state.areaCode || state.code);
    var areaKey = normalizeDeliveryArea(state.areaKey || deliveryArea || district);

    if (!deliveryArea && areaKey) {
      deliveryArea = getDeliveryAreaDisplayValue(areaKey);
    }

    return {
      district: district,
      deliveryArea: deliveryArea,
      area: area,
      areaCode: areaCode,
      areaKey: areaKey,
    };
  }

  function getZapietAreaStateFromCart(cart) {
    cart = getEffectiveCart(cart);

    return buildZapietAreaState({
      district: getCartAttributeValue(cart, 'Zapiet District') || getCartAttributeValue(cart, 'delivery_area'),
      deliveryArea: getCartAttributeValue(cart, 'delivery_area'),
      area: getCartAttributeValue(cart, 'Zapiet Area') || getCartAttributeValue(cart, 'Zapiet Location'),
      areaCode: getCartAttributeValue(cart, 'Zapiet Area Code'),
      areaKey: getCartAttributeValue(cart, 'delivery_rule'),
    });
  }

  function getEffectiveZapietAreaState(cart) {
    var state = latestZapietAreaState;

    if (!state || (!state.district && !state.area && !state.areaCode && !state.deliveryArea && !state.areaKey)) {
      state = getZapietAreaStateFromCart(cart);
    }

    return buildZapietAreaState(state);
  }

  function setLatestZapietAreaState(nextState, cart) {
    var baseState = getEffectiveZapietAreaState(cart);
    nextState = nextState || {};

    latestZapietAreaState = buildZapietAreaState({
      district: getMergedStateValue(nextState, baseState, 'district'),
      deliveryArea: getMergedStateValue(nextState, baseState, 'deliveryArea'),
      area: getMergedStateValue(nextState, baseState, 'area'),
      areaCode: getMergedStateValue(nextState, baseState, 'areaCode'),
      areaKey: getMergedStateValue(nextState, baseState, 'areaKey'),
    });

    return latestZapietAreaState;
  }

  function hasMeaningfulZapietAreaState(state) {
    state = state || {};
    return !!(state.district || state.area || state.areaCode || state.deliveryArea || state.areaKey);
  }

  function getZapietAreaAttributeParams(state) {
    state = buildZapietAreaState(state);

    return {
      'attributes[delivery_area]': state.deliveryArea || '',
      'attributes[delivery_rule]': state.areaKey || '',
      'attributes[Zapiet District]': state.district || '',
      'attributes[Zapiet Area]': state.area || '',
      'attributes[Zapiet Location]': state.area || '',
      'attributes[Zapiet Area Code]': '',
    };
  }

  function syncCartAttributeMap(params, options) {
    if (deliveryAreaSyncInFlight) return false;

    options = options || {};
    deliveryAreaSyncInFlight = true;
    applyCheckoutState();

    postForm(
      '/cart/update.js',
      params,
      function (cart) {
        deliveryAreaSyncInFlight = false;

        if (cart && typeof cart === 'object') {
          latestCartState = cart;
          latestZapietAreaState = getZapietAreaStateFromCart(cart);
        }

        if (options.onDone) {
          options.onDone(cart);
        }

        if (options.reloadOnSuccess) {
          window.location.reload();
          return;
        }

        syncCartUiFromCart(cart);
        applyCheckoutState(cart);
      },
      function () {
        deliveryAreaSyncInFlight = false;

        if (options.onError) {
          options.onError();
        }

        if (options.reloadOnError) {
          window.location.reload();
          return;
        }

        applyCheckoutState();
      }
    );

    return true;
  }

  function syncZapietAreaAttributes(state, options) {
    var nextState = setLatestZapietAreaState(state);
    return syncCartAttributeMap(getZapietAreaAttributeParams(nextState), options);
  }

  function getZapietEventAreaState(params) {
    if (!params || typeof params !== 'object') return null;

    var district =
      params.district ||
      params.delivery_area ||
      params.deliveryArea ||
      params.zone_name ||
      params.zone ||
      '';
    var area =
      params.area ||
      params.area_name ||
      params.location_name ||
      params.locationName ||
      params.rate_name ||
      '';
    var areaCode =
      params.area_code ||
      params.areaCode ||
      params.postal_code ||
      params.postalCode ||
      params.code ||
      '';

    if (!district && !area && !areaCode) return null;

    return buildZapietAreaState({
      district: district,
      deliveryArea: district,
      area: area,
      areaCode: areaCode,
    });
  }

  function syncZapietAreaStateFromParams(params, options) {
    var nextState = getZapietEventAreaState(params);
    if (!nextState) return;

    nextState = setLatestZapietAreaState(nextState);

    if (!hasMeaningfulZapietAreaState(nextState) || !(options && options.persist)) {
      return;
    }

    syncZapietAreaAttributes(nextState, {
      reloadOnSuccess: false,
    });
  }

  function normalizeZapietMethod(value) {
    var method = String(value || '')
      .toLowerCase()
      .replace(/\s+/g, ' ')
      .trim();

    if (!method) return '';
    if (method.indexOf('pickup') !== -1) return 'pickup';
    if (method.indexOf('delivery') !== -1) return 'delivery';
    if (method.indexOf('shipping') !== -1) return 'shipping';
    return method;
  }

  function getZapietSelectionDetails(params, cart, options) {
    cart = getEffectiveCart(cart);
    options = options || {};
    var includeCartFallback = options.includeCartFallback !== false;

    var method = normalizeZapietMethod(
      (params && (params.method || params.checkout_method)) ||
        (includeCartFallback ? getCartAttributeValue(cart, 'Checkout-Method') : '')
    );
    var pickupDate = includeCartFallback ? getCartAttributeValue(cart, 'Pickup-Date') : '';
    var deliveryDate = includeCartFallback ? getCartAttributeValue(cart, 'Delivery-Date') : '';
    var shippingDate = includeCartFallback ? getCartAttributeValue(cart, 'Shipping-Date') : '';
    var pickupTime = includeCartFallback ? getCartAttributeValue(cart, 'Pickup-Time') : '';
    var deliveryTime = includeCartFallback ? getCartAttributeValue(cart, 'Delivery-Time') : '';
    var pickupLocationId = includeCartFallback ? getCartAttributeValue(cart, 'Pickup-Location-Id') : '';
    var deliveryLocationId = includeCartFallback ? getCartAttributeValue(cart, 'Delivery-Location-Id') : '';

    return {
      method: method,
      date: String((params && params.date) || pickupDate || deliveryDate || shippingDate || '').trim(),
      time: String((params && (params.start_time || params.time)) || pickupTime || deliveryTime || '').trim(),
      locationId: String((params && params.location_id) || pickupLocationId || deliveryLocationId || '').trim(),
    };
  }

  function getZapietSelectionValidation(params, cart) {
    if (!hasShippingRequiredItems(cart) || window.seExpressInCart || !isZapietCartWidgetActive()) {
      return {
        valid: true,
        message: '',
      };
    }

    var useCurrentSessionOnly = zapietSelectionStarted && !zapietCheckoutReady;
    var details = getZapietSelectionDetails(params, cart, {
      includeCartFallback: !useCurrentSessionOnly,
    });

    if (!details.method) {
      return {
        valid: false,
        message: 'Please choose delivery, pickup, or shipping before checkout.',
      };
    }

    if (details.method === 'delivery') {
      if (!details.date) {
        return {
          valid: false,
          message: 'Please choose a delivery date before checkout.',
        };
      }
    }

    if (details.method === 'pickup') {
      if (!details.locationId) {
        return {
          valid: false,
          message: 'Please choose a pickup store before checkout.',
        };
      }

      if (!details.date) {
        return {
          valid: false,
          message: 'Please choose a pickup date before checkout.',
        };
      }
    }

    return {
      valid: true,
      message: '',
    };
  }

  function isZapietSelectionComplete(cart) {
    if (!hasShippingRequiredItems(cart)) return true;
    if (window.seExpressInCart || !isZapietCartWidgetActive()) return true;

    if (zapietCheckoutReady) return true;

    // STATE: A stale cart attribute from a previous visit should not unlock checkout until
    // the customer interacts with the current Zapiet widget session on this cart page.
    if (!zapietSelectionStarted) return false;

    return getZapietSelectionValidation(latestZapietCheckoutParams, cart).valid;
  }

  function updateZapietMethodMessage(cart, checkoutBlocked) {
    var message = document.querySelector('[data-zapiet-method-message]');
    if (!message) return;

    var validation = getZapietSelectionValidation(latestZapietCheckoutParams, cart);
    var needsMethodSelection = !zapietSelectionStarted;
    var messageText = needsMethodSelection
      ? 'Please select Local delivery or Store pickup before checkout.'
      : validation.message;
    var shouldShow =
      !!checkoutBlocked &&
      isAgreementValid(cart) &&
      hasShippingRequiredItems(cart) &&
      !window.seExpressInCart &&
      isZapietCartWidgetActive() &&
      (needsMethodSelection || !validation.valid);

    message.hidden = !shouldShow;
    message.textContent = shouldShow ? messageText : 'Please select Local delivery or Store pickup before checkout.';
  }

  function bindZapietWidgetEvents() {
    if (zapietEventBridgeInstalled) return true;
    if (!window.ZapietEvent || typeof window.ZapietEvent.listen !== 'function') return false;

    zapietEventBridgeInstalled = true;

    window.ZapietEvent.listen('widget_loaded', function () {
      zapietSelectionStarted = false;
      zapietCheckoutReady = false;
      latestZapietCheckoutParams = null;
      applyCheckoutState();
    });

    window.ZapietEvent.listen('selected_method', function (checkoutMethod) {
      zapietSelectionStarted = true;
      latestZapietCheckoutParams = {
        method: normalizeZapietMethod(checkoutMethod),
      };
      syncZapietAreaStateFromParams(checkoutMethod);
      zapietCheckoutReady = false;
      applyCheckoutState();
    });

    window.ZapietEvent.listen('locationSelected', function (params) {
      zapietSelectionStarted = true;
      latestZapietCheckoutParams = Object.assign({}, latestZapietCheckoutParams || {}, params || {});
      syncZapietAreaStateFromParams(params);
      zapietCheckoutReady = false;
      applyCheckoutState();
    });

    window.ZapietEvent.listen('enableCheckout', function (params) {
      zapietSelectionStarted = true;
      latestZapietCheckoutParams = Object.assign({}, latestZapietCheckoutParams || {}, params || {});
      syncZapietAreaStateFromParams(params, { persist: true });
      zapietCheckoutReady = true;
      applyCheckoutState();
    });

    window.ZapietEvent.listen('checkoutEnabled', function (params) {
      zapietSelectionStarted = true;
      latestZapietCheckoutParams = Object.assign({}, latestZapietCheckoutParams || {}, params || {});
      syncZapietAreaStateFromParams(params, { persist: true });
      zapietCheckoutReady = true;
      applyCheckoutState();
    });

    window.ZapietEvent.listen('disableCheckout', function (params) {
      zapietSelectionStarted = true;
      latestZapietCheckoutParams = Object.assign({}, latestZapietCheckoutParams || {}, params || {});
      zapietCheckoutReady = false;
      applyCheckoutState();
    });

    window.ZapietEvent.listen('checkoutDisabled', function (params) {
      zapietSelectionStarted = true;
      latestZapietCheckoutParams = Object.assign({}, latestZapietCheckoutParams || {}, params || {});
      zapietCheckoutReady = false;
      applyCheckoutState();
    });

    return true;
  }

  function initZapietCheckoutValidation() {
    if (window.seZapietCheckoutValidationInstalled) return;
    window.seZapietCheckoutValidationInstalled = true;

    var previousValidation = typeof window.customCheckoutValidation === 'function' ? window.customCheckoutValidation : null;

    window.customCheckoutValidation = function (params, callback) {
      function finish(previousValid) {
        if (!previousValid) {
          callback(false);
          return;
        }

        if (params) {
          zapietSelectionStarted = true;
          latestZapietCheckoutParams = Object.assign({}, latestZapietCheckoutParams || {}, params);
        }

        var validation = getZapietSelectionValidation(params);
        if (!validation.valid) {
          applyCheckoutState();
          callback(false);
          return;
        }

        updateZapietMethodMessage(getEffectiveCart(), false);
        callback(true);
      }

      if (!previousValidation) {
        finish(true);
        return;
      }

      previousValidation(params, function (result) {
        finish(result !== false);
      });
    };
  }

  function getDeliveryAreaDisplayValue(areaKey) {
    if (areaKey === 'hk_island') return 'Hong Kong Island';
    if (areaKey === 'kowloon') return 'Kowloon';
    if (areaKey === 'new_territories') return 'New Territories';
    return '';
  }

  function getZapietSameDayConfig() {
    var configNode = document.querySelector('[data-zapiet-same-day-config]');
    var fallbackMinimumTotal = 100000;

    function readBooleanAttribute(attributeName, fallbackValue) {
      if (!configNode) return fallbackValue;

      var value = configNode.getAttribute(attributeName);
      if (value === 'true') return true;
      if (value === 'false') return false;
      return fallbackValue;
    }

    function readNumberAttribute(attributeName, fallbackValue) {
      if (!configNode) return fallbackValue;

      var value = parseInt(configNode.getAttribute(attributeName) || '', 10);
      if (isNaN(value) || value < 0) return fallbackValue;
      return value;
    }

    return {
      showOption: readBooleanAttribute('data-show-same-day-express-option', true),
      showHongKongIsland: readBooleanAttribute('data-show-same-day-hk-island', true),
      showKowloon: readBooleanAttribute('data-show-same-day-kowloon', true),
      minimumTotalCents: readNumberAttribute('data-same-day-min-total', fallbackMinimumTotal),
    };
  }

  // STATE: When the legacy selector is absent, keep using the area already resolved into the cart UI so express toggles stay interactive.
  function getDeliveryAreaFromDomState() {
    var sources = [
      document.querySelector('[data-express-checkout-wrapper]'),
      document.querySelector('[data-delivery-area-block]'),
    ];

    for (var i = 0; i < sources.length; i += 1) {
      var source = sources[i];
      if (!source) continue;

      var areaKey = normalizeDeliveryArea(
        source.getAttribute('data-selected-delivery-area') || source.dataset.selectedDeliveryArea || ''
      );

      if (areaKey) return areaKey;
    }

    return '';
  }

  function getShippingMinimumTotal() {
    var source =
      document.querySelector('[data-shipping-minimum-message]') || document.querySelector('[data-delivery-area-block]');
    if (!source) return 0;

    return parseInt(source.getAttribute('data-shipping-minimum-total') || '0', 10);
  }

  function getShippingRequiredCountFromDom() {
    var source = document.querySelector('[data-shipping-required-count]');
    if (!source) return null;

    var count = parseInt(source.getAttribute('data-shipping-required-count') || '', 10);
    return isNaN(count) ? null : count;
  }

  // RULE: Gift cards and delivery-fee products are non-shipping cart lines, so delivery rules only look at shippable merchandise.
  function itemRequiresShippingForRules(item, expressVariantIds) {
    if (!item) return false;

    var variantId = item.variant_id ? String(item.variant_id) : '';
    if (variantId && expressVariantIds.indexOf(variantId) !== -1) return false;

    return item.requires_shipping !== false;
  }

  function hasShippingRequiredItems(cart) {
    cart = getEffectiveCart(cart);
    var items = getCartItems(cart);

    if (items.length) {
      var expressVariantIds = getExpressVariantIdsFromDom();
      return items.some(function (item) {
        return itemRequiresShippingForRules(item, expressVariantIds);
      });
    }

    var domCount = getShippingRequiredCountFromDom();
    if (domCount !== null) return domCount > 0;

    return true;
  }

  function resolveDeliveryArea(cart) {
    cart = getEffectiveCart(cart);
    var areaKey = normalizeDeliveryArea(getCartAttributeValue(cart, 'delivery_area'));
    if (areaKey) return areaKey;

    var select = document.querySelector('[data-delivery-area-select]');
    if (select) {
      areaKey = normalizeDeliveryArea(select.value);
      if (areaKey) return areaKey;
    }

    return getDeliveryAreaFromDomState();
  }

  function getDeliveryAreaBlocks() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-delivery-area-block]'));
  }

  function isDeliveryAreaValid(cart) {
    var blocks = getDeliveryAreaBlocks().filter(function (wrapper) {
      return wrapper.getAttribute('data-delivery-required') === 'true';
    });
    if (!blocks.length) return true;
    if (!hasShippingRequiredItems(cart)) return true;

    if (!isShippingMethodsAvailable(cart)) return true;

    var areaKey = resolveDeliveryArea(cart);
    return !!areaKey;
  }

  function getDeliveryAvailabilityState(cart) {
    cart = getEffectiveCart(cart);
    var hasShippingItems = hasShippingRequiredItems(cart);
    var qualifyingTotal = getCartTotalExcludingExpress(cart);
    var shippingMinimumTotal = getShippingMinimumTotal();
    var shippingMethodsAvailable = !hasShippingItems || shippingMinimumTotal <= 0 || qualifyingTotal >= shippingMinimumTotal;

    return {
      hasShippingRequiredItems: hasShippingItems,
      qualifyingTotal: qualifyingTotal,
      shippingMinimumTotal: shippingMinimumTotal,
      shippingMethodsAvailable: shippingMethodsAvailable,
      areaKey: resolveDeliveryArea(cart),
    };
  }

  function isShippingMethodsAvailable(cart) {
    return getDeliveryAvailabilityState(cart).shippingMethodsAvailable;
  }

  // RULE: The cart-wide minimum order applies only when the cart contains shippable merchandise.
  function isMinimumOrderMet(cart) {
    return getDeliveryAvailabilityState(cart).shippingMethodsAvailable;
  }

  function applyPickupOnlyState(cart) {
    var availability = getDeliveryAvailabilityState(cart);
    var hideForPickupOnly = availability.hasShippingRequiredItems && !availability.shippingMethodsAvailable;
    var hideDeliveryArea = !availability.hasShippingRequiredItems || hideForPickupOnly;

    document.querySelectorAll('[data-shipping-minimum-message]').forEach(function (message) {
      message.hidden = !hideForPickupOnly;
    });

    getDeliveryAreaBlocks().forEach(function (wrapper) {
      wrapper.hidden = hideDeliveryArea;
    });
  }

  function updateDeliveryAreaUi(cart) {
    var availability = getDeliveryAvailabilityState(cart);
    var shippingMethodsAvailable = availability.shippingMethodsAvailable;
    var areaKey = resolveDeliveryArea(cart);
    var areaLabel = getDeliveryAreaDisplayValue(areaKey);

    getDeliveryAreaBlocks().forEach(function (wrapper) {
      var select = wrapper.querySelector('[data-delivery-area-select]');
      var ruleInput = wrapper.querySelector('[data-delivery-rule-input]');
      var message = wrapper.querySelector('[data-delivery-area-message]');
      var required = wrapper.getAttribute('data-delivery-required') === 'true';
      var messageText = '';

      if (select && areaLabel && select.value !== areaLabel) {
        select.value = areaLabel;
      }

      if (ruleInput) {
        ruleInput.value = areaKey;
      }

      wrapper.setAttribute('data-selected-delivery-area', areaKey);
      wrapper.hidden = !availability.hasShippingRequiredItems || !shippingMethodsAvailable;

      if (availability.hasShippingRequiredItems && shippingMethodsAvailable && required && !areaKey) {
        messageText = 'Select your delivery area before checkout.';
      }

      if (!message) return;

      message.hidden = messageText === '';
      message.textContent = messageText;
    });
  }

  function syncDeliveryAreaAttribute(value, areaKey) {
    syncCartAttributeMap({
      'attributes[delivery_area]': value || '',
      'attributes[delivery_rule]': areaKey || '',
    }, {
      reloadOnSuccess: true,
      reloadOnError: true,
    });
  }

  function getExpressVariantIdsFromDom() {
    var variantIds = [];

    document.querySelectorAll('[data-express-checkout-wrapper]').forEach(function (wrapper) {
      getExpressVariantIds(wrapper).forEach(function (variantId) {
        if (variantIds.indexOf(variantId) === -1) {
          variantIds.push(variantId);
        }
      });
    });

    return variantIds;
  }

  // RULE: Merchandise minimums ignore gift cards and express surcharges so non-shipping lines never qualify delivery rules.
  function getCartTotalExcludingExpress(cart) {
    cart = getEffectiveCart(cart);
    var expressVariantIds = getExpressVariantIdsFromDom();
    var excludedLineTotal = 0;
    var baseTotal =
      cart && typeof cart.items_subtotal_price === 'number'
        ? cart.items_subtotal_price
        : cart && typeof cart.total_price === 'number'
          ? cart.total_price
          : 0;

    getCartItems(cart).forEach(function (item) {
      var variantId = item && item.variant_id ? String(item.variant_id) : '';
      var lineTotal = item && typeof item.final_line_price === 'number' ? item.final_line_price : 0;
      if (!variantId) return;

      if (!itemRequiresShippingForRules(item, expressVariantIds)) {
        excludedLineTotal += lineTotal;
      }
    });

    return Math.max(baseTotal - excludedLineTotal, 0);
  }

  function getExpressVariantIds(wrapper) {
    return Array.prototype.slice
      .call(wrapper.querySelectorAll('[data-express-checkout]'))
      .map(function (checkbox) {
        return checkbox.getAttribute('data-variant-id');
      })
      .filter(function (variantId) {
        return !!variantId;
      });
  }

  // RULE: The merchandise subtotal qualifies express delivery, while fee-product lines are removed from the comparison so the surcharge cannot unlock itself.
  function getExpressCartState(cart, wrapper) {
    var variantIds = getExpressVariantIds(wrapper);
    var variantIdsInCart = [];

    getCartItems(cart).forEach(function (item) {
      var variantId = item && item.variant_id ? String(item.variant_id) : '';
      if (!variantId) return;

      if (variantIds.indexOf(variantId) === -1) return;

      variantIdsInCart.push(variantId);
    });

    return {
      expressInCart: variantIdsInCart.length > 0,
      qualifyingTotal: getCartTotalExcludingExpress(cart),
      variantIdsInCart: variantIdsInCart,
    };
  }

  function syncExpressSelections(wrapper, variantIdsInCart) {
    wrapper.querySelectorAll('[data-express-checkout]').forEach(function (checkbox) {
      var variantId = checkbox.getAttribute('data-variant-id');
      checkbox.checked = variantIdsInCart.indexOf(String(variantId)) !== -1;
    });
  }

  // FEATURE: Keep the express block mounted so AJAX cart updates can reveal it immediately when the threshold is crossed.
  function syncExpressCheckoutState(cart) {
    var activeExpressSelection = false;
    var availability = getDeliveryAvailabilityState(cart);
    var areaKey = resolveDeliveryArea(cart);

    document.querySelectorAll('[data-express-checkout-wrapper]').forEach(function (wrapper) {
      var minTotal = parseInt(wrapper.getAttribute('data-express-min-total') || '0', 10);
      var expressState = getExpressCartState(cart, wrapper);
      var isEligible = availability.hasShippingRequiredItems && expressState.qualifyingTotal >= minTotal;
      var shouldShow = isEligible || expressState.expressInCart;

      wrapper.dataset.expressEligible = isEligible ? 'true' : 'false';
      wrapper.dataset.expressQualifyingTotal = String(expressState.qualifyingTotal);
      wrapper.dataset.selectedDeliveryArea = areaKey;
      wrapper.hidden = !shouldShow;
      wrapper.classList.toggle('express-checkout--hidden', !shouldShow);

      syncExpressSelections(wrapper, expressState.variantIdsInCart);

      if (expressState.expressInCart && isEligible) {
        activeExpressSelection = true;
      }
    });

    window.seExpressInCart = activeExpressSelection;
  }

  function applyExpressAreaState(cart) {
    var availability = getDeliveryAvailabilityState(cart);
    var shippingMethodsAvailable = availability.hasShippingRequiredItems && availability.shippingMethodsAvailable;

    document.querySelectorAll('[data-express-checkout-wrapper]').forEach(function (wrapper) {
      var areaMessage = wrapper.querySelector('[data-express-area-message]');

      // UI: Keep both express options visible so the customer can choose the surcharge directly, independent of Zapiet's selected delivery area.
      wrapper.querySelectorAll('[data-express-option-label]').forEach(function (label) {
        label.hidden = !shippingMethodsAvailable;
      });

      if (!areaMessage) return;

      areaMessage.hidden = true;
      areaMessage.textContent = '';
    });
  }

  // UX: Reuse the inline express status slot for cart action failures so the checkbox does not appear unresponsive.
  function setExpressActionMessage(wrapper, messageText) {
    if (!wrapper) return;

    var message = wrapper.querySelector('[data-express-area-message]');
    if (!message) return;

    message.hidden = !messageText;
    message.textContent = messageText || '';
  }

  function removeAreaInvalidExpressSelections(cart) {
    return;
  }

  // SAFETY: If the merchandise subtotal falls back under the threshold, remove any selected express fee lines before checkout can continue with an invalid surcharge.
  function removeThresholdInvalidExpressSelections(cart) {
    if (expressWindowSyncInFlight || expressThresholdSyncInFlight) return;

    var variantIdsToRemove = [];

    document.querySelectorAll('[data-express-checkout-wrapper]').forEach(function (wrapper) {
      var minTotal = parseInt(wrapper.getAttribute('data-express-min-total') || '0', 10);
      var expressState = getExpressCartState(cart, wrapper);

      if (expressState.qualifyingTotal >= minTotal) return;

      expressState.variantIdsInCart.forEach(function (variantId) {
        if (variantIdsToRemove.indexOf(variantId) === -1) {
          variantIdsToRemove.push(variantId);
        }
      });
    });

    if (!variantIdsToRemove.length) return;

    expressThresholdSyncInFlight = true;
    applyCheckoutState(cart);

    function removeNext(index) {
      if (index >= variantIdsToRemove.length) {
        window.location.reload();
        return;
      }

      setVariantQty(
        variantIdsToRemove[index],
        0,
        function () {
          removeNext(index + 1);
        },
        function () {
          removeNext(index + 1);
        }
      );
    }

    removeNext(0);
  }

  function syncCartUiFromCart(cart) {
    if (!cart) return;
    latestCartState = cart;
    latestZapietAreaState = getZapietAreaStateFromCart(cart);

    updateCheckoutButtonAmount(cart);
    applyPickupOnlyState(cart);
    updateDeliveryAreaUi(cart);
    syncExpressCheckoutState(cart);
    applyExpressAreaState(cart);
    applyCheckoutState(cart);
    removeAreaInvalidExpressSelections(cart);
    removeThresholdInvalidExpressSelections(cart);
    applyExpressWindowState();
    removeUnavailableExpressSelections();
    unlockZapietIfExpress();
  }

  // COMPONENT: Express delivery window — keeps same-day delivery tied to Hong Kong operating hours even after the cart loads.
  function getTimePartsInZone(timeZone) {
    try {
      return new Intl.DateTimeFormat('en-GB', {
        timeZone: timeZone,
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
      }).formatToParts(new Date());
    } catch (error) {
      return new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Asia/Hong_Kong',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
      }).formatToParts(new Date());
    }
  }

  function getExpressMinutesInZone(timeZone) {
    var parts = getTimePartsInZone(timeZone);
    var hour = 0;
    var minute = 0;

    parts.forEach(function (part) {
      if (part.type === 'hour') hour = parseInt(part.value, 10);
      if (part.type === 'minute') minute = parseInt(part.value, 10);
    });

    return hour * 60 + minute;
  }

  function isExpressWindowOpen(wrapper) {
    var startHour = parseInt(wrapper.getAttribute('data-express-window-start') || '10', 10);
    var endHour = parseInt(wrapper.getAttribute('data-express-window-end') || '16', 10);
    var timeZone = wrapper.getAttribute('data-express-timezone') || 'Asia/Hong_Kong';
    var currentMinutes = getExpressMinutesInZone(timeZone);
    var startMinutes = startHour * 60;
    var endMinutes = endHour * 60;

    return currentMinutes >= startMinutes && currentMinutes < endMinutes;
  }

  function shouldShowExpressWrapper(wrapper) {
    if (!wrapper) return false;

    var isEligible = wrapper.dataset.expressEligible === 'true';
    var hasSelection = Array.prototype.slice
      .call(wrapper.querySelectorAll('[data-express-checkout]'))
      .some(function (checkbox) {
        return checkbox.checked;
      });

    return isEligible || hasSelection;
  }

  function applyExpressWindowState() {
    document.querySelectorAll('[data-express-checkout-wrapper]').forEach(function (wrapper) {
      var isOpen = isExpressWindowOpen(wrapper);
      var status = wrapper.querySelector('[data-express-status]');
      var closedMessage = wrapper.getAttribute('data-express-closed-message') || '';
      var shouldShow = shouldShowExpressWrapper(wrapper) && isOpen;

      wrapper.dataset.expressAvailable = isOpen ? 'true' : 'false';
      wrapper.hidden = !shouldShow;
      wrapper.classList.toggle('express-checkout--hidden', !shouldShow);
      wrapper.classList.toggle('express-checkout--closed', !isOpen);

      wrapper.querySelectorAll('[data-express-checkout]').forEach(function (checkbox) {
        checkbox.disabled = !isOpen;

        if (isOpen) {
          checkbox.removeAttribute('aria-disabled');
        } else {
          checkbox.setAttribute('aria-disabled', 'true');
        }
      });

      if (!status) return;

      status.hidden = true;
      status.textContent = shouldShow && !isOpen ? closedMessage : '';
    });
  }

  // EVENT: When the window is closed, any already-selected express fee products are removed so checkout cannot continue with an ineligible same-day surcharge.
  function removeUnavailableExpressSelections() {
    if (expressWindowSyncInFlight) return;

    var variantIds = [];

    document.querySelectorAll('[data-express-checkout-wrapper][data-express-available="false"] [data-express-checkout]').forEach(function (checkbox) {
      if (!checkbox.checked) return;

      var variantId = checkbox.getAttribute('data-variant-id');
      if (!variantId || variantIds.indexOf(String(variantId)) !== -1) return;

      variantIds.push(String(variantId));
    });

    if (!variantIds.length) return;

    expressWindowSyncInFlight = true;
    applyCheckoutState();

    function removeNext(index) {
      if (index >= variantIds.length) {
        window.location.reload();
        return;
      }

      setVariantQty(
        variantIds[index],
        0,
        function () {
          removeNext(index + 1);
        },
        function () {
          removeNext(index + 1);
        }
      );
    }

    removeNext(0);
  }

  function handleExpressToggle(event) {
    var checkbox = event.target;
    if (!checkbox || !checkbox.matches('[data-express-checkout]')) return;
    if (expressAreaSyncInFlight || expressWindowSyncInFlight) return;

    var wrapper = checkbox.closest('[data-express-checkout-wrapper]');

    if (wrapper && wrapper.dataset.expressAvailable === 'false') {
      checkbox.checked = false;
      return;
    }

    var variantId = checkbox.getAttribute('data-variant-id');
    var quantity = parseInt(checkbox.getAttribute('data-quantity') || '1', 10);

    if (!variantId || quantity <= 0) {
      checkbox.checked = false;
      return;
    }

    function reloadCart() {
      window.location.reload();
    }

    setExpressActionMessage(wrapper, '');

    if (checkbox.checked) {
      var allExpress = Array.prototype.slice.call(document.querySelectorAll('[data-express-checkout]'));
      var params = {};

      allExpress.forEach(function (cb) {
        if (!cb) return;

        var otherId = cb.getAttribute('data-variant-id');
        if (!otherId) return;

        cb.checked = String(otherId) === String(variantId);
        params['updates[' + String(otherId) + ']'] = String(String(otherId) === String(variantId) ? quantity : 0);
      });

      postForm(
        '/cart/update.js',
        params,
        reloadCart,
        function () {
          checkbox.checked = false;
          setExpressActionMessage(
            wrapper,
            'Unable to update express delivery right now. Please refresh the cart and confirm the Express delivery product is available.'
          );
        }
      );
      return;
    }

    setVariantQty(
      variantId,
      0,
      reloadCart,
      function () {
        checkbox.checked = true;
        setExpressActionMessage(
          wrapper,
          'Unable to update express delivery right now. Please refresh the cart and try again.'
        );
      }
    );
  }

  function refreshCartUi() {
    initFreeshippingBars();
    initFsbAddonsCarousels();
    initFsbAddonQtySteppers();
    initCheckoutTotalObserver();
    initCheckoutStateObserver();
    syncAgreementAttributeIfNeeded();
    syncCheckoutButtonToSummary();
    applyPickupOnlyState();
    updateDeliveryAreaUi();
    applyExpressAreaState();
    applyExpressWindowState();
    removeUnavailableExpressSelections();
    applyCheckoutState();
    syncCartSavingsState();
    unlockZapietIfExpress();
  }

  document.addEventListener('change', function (event) {
    if (event.target && event.target.matches('[data-delivery-area-select]')) {
      var areaKey = normalizeDeliveryArea(event.target.value);
      var wrapper = event.target.closest('[data-delivery-area-block]');
      var ruleInput = wrapper ? wrapper.querySelector('[data-delivery-rule-input]') : null;

      if (ruleInput) {
        ruleInput.value = areaKey;
      }

      updateDeliveryAreaUi();
      applyExpressAreaState();
      applyCheckoutState();
      syncDeliveryAreaAttribute(event.target.value, areaKey);
      return;
    }

    if (event.target && event.target.matches('[data-cart-agreement]')) {
      syncAgreementAttributeIfNeeded();
      applyCheckoutState();
      return;
    }

    if (event.target && event.target.matches('[data-quantity-input]')) {
      scheduleCheckoutButtonSync();
    }

    handleExpressToggle(event);
  });

  document.addEventListener('click', function (event) {
    var checkoutTrigger = event.target && event.target.closest('button[name="checkout"], input[name="checkout"]');
    if (checkoutTrigger) {
      if (isZapietOwnedCheckoutTrigger(checkoutTrigger)) {
        event.preventDefault();

        if (!isCheckoutAllowed()) {
          event.stopImmediatePropagation();
          applyCheckoutState();
        }

        return;
      }

      if (!isCheckoutAllowed()) {
        event.preventDefault();
        event.stopImmediatePropagation();
        applyCheckoutState();
        return;
      }
    }

    if (
      event.target &&
      event.target.closest('[data-increase-quantity], [data-decrease-quantity], [data-remove-key]')
    ) {
      scheduleCheckoutButtonSync();
    }
  });

  document.addEventListener('theme:cart:change', function (event) {
    document.dispatchEvent(new CustomEvent('fsb:cart:update'));
    applyCheckoutState();
    syncCartSavingsState();
    syncCartUiFromCart(event.detail && event.detail.cart);
    scheduleCheckoutButtonSync();

    if (fsbRefreshTimer) clearTimeout(fsbRefreshTimer);
    fsbRefreshTimer = setTimeout(function () {
      refreshFreeshippingSection();
    }, 120);
  });

  document.addEventListener('theme:cart:reload', function () {
    setTimeout(refreshCartUi, 50);
    scheduleCheckoutButtonSync();
  });

  // EVENT: Free gift reconciliation can add or remove cart lines after quantity changes, so checkout stays locked until that promotion pass has settled.
  document.addEventListener('sk:free-gift:sync-state', function () {
    applyCheckoutState();
  });

  document.addEventListener('submit', function (event) {
    var checkoutBtn = event.submitter;
    if (!checkoutBtn || !checkoutBtn.matches('button[name="checkout"], input[name="checkout"]')) return;

    if (isZapietOwnedCheckoutTrigger(checkoutBtn)) {
      event.preventDefault();
      applyCheckoutState();
      return;
    }

    if (!isCheckoutAllowed()) {
      event.preventDefault();
      applyCheckoutState();
    }
  });

  document.addEventListener('shopify:section:load', function () {
    setTimeout(refreshCartUi, 80);
  });

  document.addEventListener('DOMContentLoaded', function () {
    initZapietCheckoutValidation();
    bindZapietWidgetEvents();
    refreshCartUi();
    initCheckoutStateObserver();
    fetch('/cart.js', {
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
      },
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Cart sync failed: ' + response.status);
        }

        return response.json();
      })
      .then(function (cart) {
        syncAgreementCheckboxStateFromCart(cart);
        syncCartUiFromCart(cart);
      })
      .catch(function (error) {
        console.error(error);
      });
    setTimeout(bindZapietWidgetEvents, 300);
    setTimeout(bindZapietWidgetEvents, 1200);
    setTimeout(unlockZapietIfExpress, 500);
    setTimeout(unlockZapietIfExpress, 1500);
    setInterval(function () {
      bindZapietWidgetEvents();
      applyExpressWindowState();
      removeUnavailableExpressSelections();
    }, 60000);
  });

  // --- CUSTOM ZAPIET DROPDOWN LOGIC ---
  function initZapietDistrictDropdowns() {
    if (!window.HK_DISTRICT_DATA) return;
    
    var zapietObserver = new MutationObserver(function() {
      // Look for the Zapiet container
      var zapietApp = document.querySelector('#storePickupApp') || document.querySelector('.zapiet-widget-wrapper') || document.querySelector('#zapiet-checkout-methods');
      if (!zapietApp) return;

      // Find the text input used specifically for delivery postal code/distance validation
      // Avoid accidentally capturing the Store Pickup search input
      var zapietInput = zapietApp.querySelector('.zapiet-delivery-validator__input') 
        || zapietApp.querySelector('input[name="zapiet_postal_code"]')
        || zapietApp.querySelector('input[name="postal_code"]');
      
      if (!zapietInput) {
        var valBtn = zapietApp.querySelector('.zapiet-delivery-validator__btn');
        if (valBtn && valBtn.parentElement) {
          zapietInput = valBtn.parentElement.querySelector('input[type="text"]');
        }
      }

      if (!zapietInput) {
        var textInputs = Array.prototype.slice.call(zapietApp.querySelectorAll('input[type="text"]'));
        for (var i = 0; i < textInputs.length; i++) {
          var p = (textInputs[i].placeholder || '').toLowerCase();
          if (p.indexOf('district') !== -1 || p.indexOf('postal') !== -1 || p.indexOf('area') !== -1) {
            zapietInput = textInputs[i];
            break;
          }
        }
      }

      // If we somehow still grabbed an input living strictly inside a pickup wrapper, ignore it.
      if (zapietInput) {
        var pickupWrapper = zapietInput.closest('[class*="pickup"], [id*="pickup"]:not(#storePickupApp)');
        var deliveryWrapper = zapietInput.closest('[class*="delivery"], [id*="delivery"]');
        if (pickupWrapper && !deliveryWrapper) {
          zapietInput = null;
        }
      }

      if (!zapietInput) return;

      // Ensure we haven't already initialized our dropdowns over this input
      if (!zapietInput.hasAttribute('data-custom-dropdowns-injected') && !document.querySelector('#zapiet-custom-district-select')) {
        zapietInput.setAttribute('data-custom-dropdowns-injected', 'true');
        
        var wrapper = zapietInput.parentElement;
        
        // Find the Zapiet search button (usually a submit button or a button next to the input)
        var zapietSearchBtn = wrapper.querySelector('button') || zapietApp.querySelector('button[type="submit"]') || zapietInput.nextElementSibling;
        if (zapietSearchBtn && zapietSearchBtn.tagName !== 'BUTTON') {
           zapietSearchBtn = zapietApp.querySelector('button.zapiet-delivery-validator__btn') || zapietApp.querySelector('.zapiet-delivery-validator__btn');
        }

        // Hide Zapiet's original wrapper visually but keep it functionally available
        // We do this instead of displaying none to allow Zapiet's event listeners to fire
        wrapper.style.position = 'absolute';
        wrapper.style.opacity = '0';
        wrapper.style.pointerEvents = 'none';
        wrapper.style.zIndex = '-1';
        wrapper.style.height = '0';
        wrapper.style.overflow = 'hidden';

        // Create a custom container that takes up actual layout space
        var customContainer = document.createElement('div');
        customContainer.id = 'zapiet-custom-dropdowns-container';
        customContainer.style.display = 'block';
        customContainer.style.width = '100%';
        customContainer.style.paddingTop = '10px';
        customContainer.style.marginBottom = '20px';

        // Create District Dropdown
        var districtSelect = document.createElement('select');
        districtSelect.id = 'zapiet-custom-district-select';
        
        // Match standard Shopify select styles
        districtSelect.style.width = '100%';
        districtSelect.style.padding = '10px';
        districtSelect.style.marginBottom = '10px';
        districtSelect.style.border = '1px solid #ccc';
        districtSelect.style.borderRadius = '4px';
        districtSelect.style.backgroundColor = '#fff';
        districtSelect.style.display = 'block';
        districtSelect.style.fontSize = '16px';
        districtSelect.style.appearance = 'none';
        districtSelect.style.backgroundImage = 'url("data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%23000%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E")';
        districtSelect.style.backgroundRepeat = 'no-repeat';
        districtSelect.style.backgroundPosition = 'right 10px top 50%';
        districtSelect.style.backgroundSize = '12px auto';

        var isChinese = window.HK_DISTRICT_LANG && window.HK_DISTRICT_LANG.indexOf('zh') === 0;
        var selectDistrictText = isChinese ? '選擇地區' : 'Select District';
        districtSelect.innerHTML = '<option value="">' + selectDistrictText + '</option>';

        var expressEnabled = false;
        var expressCheckboxWrapper = document.createElement('div');
        expressCheckboxWrapper.id = 'zapiet-express-eligibility-wrapper';
        expressCheckboxWrapper.style.display = 'none';
        expressCheckboxWrapper.style.alignItems = 'center';
        expressCheckboxWrapper.style.justifyContent = 'flex-start';
        expressCheckboxWrapper.style.gap = '10px';
        expressCheckboxWrapper.style.marginBottom = '10px';
        expressCheckboxWrapper.style.fontSize = '14px';
        expressCheckboxWrapper.style.color = '#333';
        expressCheckboxWrapper.style.lineHeight = '1.4';

        var expressCheckbox = document.createElement('input');
        expressCheckbox.type = 'checkbox';
        expressCheckbox.id = 'zapiet-express-checkbox';
        expressCheckbox.style.flex = '0 0 auto';
        expressCheckbox.style.width = '18px';
        expressCheckbox.style.height = '18px';
        expressCheckbox.style.margin = '0';
        expressCheckbox.style.cursor = 'pointer';
        expressCheckbox.style.accentColor = '#1f4d33';
        expressCheckbox.style.borderRadius = '5px';
        expressCheckbox.style.boxShadow = '0 0 0 1px rgba(31, 77, 51, 0.16)';

        var expressLabelText = document.createElement('label');
        expressLabelText.htmlFor = 'zapiet-express-checkbox';
        expressLabelText.style.cursor = 'pointer';
        expressLabelText.style.margin = '0';
        expressLabelText.style.fontSize = '14px';
        expressLabelText.style.fontWeight = '600';
        expressLabelText.style.lineHeight = '1.3';
        expressLabelText.style.letterSpacing = '0.01em';
        expressLabelText.style.color = '#203126';
        var expressLabelBaseText = isChinese
          ? '即日特快送貨'
          : 'Same day express delivery';
        expressLabelText.innerText = expressLabelBaseText;

        expressCheckboxWrapper.style.alignItems = 'center';
        expressCheckboxWrapper.style.gap = '12px';
        expressCheckboxWrapper.style.padding = '12px 14px';
        expressCheckboxWrapper.style.backgroundColor = '#ffffff';
        expressCheckboxWrapper.style.border = '1px solid rgba(31, 77, 51, 0.14)';
        expressCheckboxWrapper.style.borderRadius = '10px';
        expressCheckboxWrapper.style.boxShadow = '0 8px 24px rgba(31, 77, 51, 0.06)';

        expressCheckboxWrapper.appendChild(expressCheckbox);
        expressCheckboxWrapper.appendChild(expressLabelText);

        var expressHint = document.createElement('div');
        expressHint.id = 'zapiet-express-eligibility-hint';
        expressHint.style.marginBottom = '10px';
        expressHint.style.padding = '10px 14px';
        expressHint.style.fontSize = '14px';
        expressHint.style.fontWeight = '500';
        expressHint.style.color = '#725400';
        expressHint.style.lineHeight = '1.35';
        expressHint.style.backgroundColor = '#fffaf1';
        expressHint.style.border = '1px solid rgba(224, 168, 0, 0.28)';
        expressHint.style.borderLeft = '4px solid #e0a800';
        expressHint.style.borderRadius = '10px';
        expressHint.textContent = '';
        
        var districtTranslations = {
          "Hong Kong Island": "香港島",
          "Kowloon": "九龍",
          "New Territories": "新界",
          "Outlying Islands": "大嶼山南及離島",
        };

        function getExpressSubtotal() {
          return getCartTotalExcludingExpress(latestCartState) || 0;
        }

        function getExpressThreshold() {
          return getZapietSameDayConfig().minimumTotalCents;
        }

        function isExpressThresholdMet() {
          return getExpressSubtotal() >= getExpressThreshold();
        }

        function getExpressRemainingText() {
          var expressThreshold = getExpressThreshold();
          var remaining = Math.max(expressThreshold - getExpressSubtotal(), 0);
          if (!remaining) return '';
          var amountText = formatCartMoney(remaining);
          if (!amountText) {
            var fallbackAmount = (remaining / 100).toFixed(2);
            amountText = (theme && theme.currencyCode ? theme.currencyCode + ' ' : 'HK$') + fallbackAmount;
          }
          return isChinese
            ? '再消費 ' + amountText + ' 即可享有即日特快送貨。'
            : 'Spend ' + amountText + ' more to be eligible for Same day express delivery.';
        }

        function getEnabledSameDayDistricts() {
          var config = getZapietSameDayConfig();
          var districts = [];

          if (config.showHongKongIsland) {
            districts.push('Hong Kong Island');
          }

          if (config.showKowloon) {
            districts.push('Kowloon');
          }

          return districts;
        }

        function isSameDayOptionVisible() {
          var config = getZapietSameDayConfig();
          return config.showOption && getEnabledSameDayDistricts().length > 0;
        }

        function getExpressDistricts() {
          return getEnabledSameDayDistricts();
        }

        function isExpressDistrictSelected(selectedDistrict) {
          if (!selectedDistrict) return false;
          return getExpressDistricts().indexOf(selectedDistrict) !== -1;
        }

        function updateExpressCheckboxLabel(selectedDistrict) {
          var feeSuffix = '';

          if (selectedDistrict === 'Hong Kong Island') {
            feeSuffix = ' + HKD 200';
          } else if (selectedDistrict === 'Kowloon') {
            feeSuffix = ' + HKD 150';
          }

          expressLabelText.innerText = expressLabelBaseText + feeSuffix;
        }

        function buildDistrictOptions(selectedDistrict) {
          var previousSelection = selectedDistrict || districtSelect.value;

          districtSelect.innerHTML = '<option value="">' + selectDistrictText + '</option>';
          var districts = Object.keys(window.HK_DISTRICT_DATA);

          districts.forEach(function (district) {
            if (!window.HK_DISTRICT_DATA[district]) return;
            var option = document.createElement('option');
            option.value = district;
            var label = (isChinese && districtTranslations[district]) ? districtTranslations[district] : district;
            option.innerText = label;
            districtSelect.appendChild(option);
          });

          if (previousSelection && districts.indexOf(previousSelection) !== -1) {
            districtSelect.value = previousSelection;
          }
        }

        function buildAreaOptions(selectedDistrict) {
          areaSelect.innerHTML = '<option value="">' + selectAreaText + '</option>';
          if (!selectedDistrict || !window.HK_DISTRICT_DATA[selectedDistrict]) {
            areaSelect.style.display = 'none';
            return;
          }

          var areas = window.HK_DISTRICT_DATA[selectedDistrict];
          var langField = isChinese ? 'chinese' : 'english';

          areas.forEach(function (area) {
            var label = area[langField] || area['english'];
            var option = document.createElement('option');
            option.value = area.code + (expressEnabled && isSameDayOptionVisible() ? '-E' : '');
            option.innerText = label;
            areaSelect.appendChild(option);
          });

          areaSelect.style.display = 'block';
        }

        function getSelectedAreaLabel() {
          var selectedOption = areaSelect.options[areaSelect.selectedIndex];
          if (!selectedOption || !selectedOption.value) return '';
          return getTrimmedString(selectedOption.text);
        }

        function getAreaSelectValueForState(state) {
          var normalizedCode = getTrimmedString(state && state.areaCode);
          var normalizedArea = getTrimmedString(state && state.area);

          if (!normalizedCode && !normalizedArea) return '';

          for (var index = 0; index < areaSelect.options.length; index += 1) {
            var option = areaSelect.options[index];
            if (!option || !option.value) continue;

            if (normalizedCode && option.value === normalizedCode) {
              return option.value;
            }

            if (normalizedCode && normalizedCode.slice(-2) === '-E' && option.value === normalizedCode.replace(/-E$/, '')) {
              return option.value;
            }

            if (normalizedArea && getTrimmedString(option.text) === normalizedArea) {
              return option.value;
            }
          }

          return '';
        }

        function applySavedZapietSelection() {
          var savedState = getEffectiveZapietAreaState();
          if (!hasMeaningfulZapietAreaState(savedState)) return;

          if (savedState.district) {
            districtSelect.value = savedState.district;
          }

          if (savedState.areaCode && savedState.areaCode.slice(-2) === '-E') {
            expressEnabled = true;
            expressCheckbox.checked = true;
          }

          refreshExpressEligibilityUi();

          var selectedValue = getAreaSelectValueForState(savedState);
          if (selectedValue) {
            areaSelect.value = selectedValue;
          }
        }

        function persistCustomZapietSelection(nextState) {
          syncZapietAreaAttributes(nextState, {
            reloadOnSuccess: false,
          });
        }

        function resetZapietWidget() {
          if (zapietInput) {
            zapietInput.value = '';
            zapietInput.dispatchEvent(new Event('input', { bubbles: true }));
            zapietInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }

        function refreshExpressEligibilityUi() {
          var optionVisible = isSameDayOptionVisible();
          var selectedDistrict = districtSelect.value;

          buildDistrictOptions(selectedDistrict);
          selectedDistrict = districtSelect.value;
          updateExpressCheckboxLabel(selectedDistrict);

          var districtEligible = isExpressDistrictSelected(selectedDistrict);
          var eligible = optionVisible && districtEligible && isExpressThresholdMet();

          expressHint.textContent = optionVisible && districtEligible ? getExpressRemainingText() : '';
          expressHint.hidden = !optionVisible || !districtEligible || eligible;
          expressCheckboxWrapper.style.display = eligible ? 'flex' : 'none';

          if (!eligible) {
            expressCheckbox.checked = false;
            expressEnabled = false;
          }

          buildAreaOptions(selectedDistrict);
        }

        expressCheckbox.addEventListener('change', function () {
          var previousExpressEnabled = expressEnabled;

          if (!isSameDayOptionVisible() || !isExpressDistrictSelected(districtSelect.value) || !isExpressThresholdMet()) {
            expressCheckbox.checked = false;
            expressEnabled = false;
            areaSelect.value = '';
            resetZapietWidget();
            triggerZapietCheck(zapietInput, '');
            refreshExpressEligibilityUi();
            return;
          }

          expressEnabled = expressCheckbox.checked;

          if (previousExpressEnabled !== expressEnabled) {
            areaSelect.value = '';
            resetZapietWidget();
            triggerZapietCheck(zapietInput, '');
          }

          refreshExpressEligibilityUi();
        });

        document.addEventListener('theme:cart:change', function () {
          refreshExpressEligibilityUi();
        });

        document.addEventListener('theme:cart:reload', function () {
          refreshExpressEligibilityUi();
        });
        
        // Create Area Dropdown
        var areaSelect = document.createElement('select');
        areaSelect.id = 'zapiet-custom-area-select';
        areaSelect.style.width = '100%';
        areaSelect.style.padding = '10px';
        areaSelect.style.marginBottom = '10px';
        areaSelect.style.border = '1px solid #ccc';
        areaSelect.style.borderRadius = '4px';
        areaSelect.style.backgroundColor = '#fff';
        areaSelect.style.display = 'none'; // Initially hidden
        areaSelect.style.fontSize = '16px';
        areaSelect.style.appearance = 'none';
        areaSelect.style.backgroundImage = 'url("data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%23000%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E")';
        areaSelect.style.backgroundRepeat = 'no-repeat';
        areaSelect.style.backgroundPosition = 'right 10px top 50%';
        areaSelect.style.backgroundSize = '12px auto';
        
        var selectAreaText = isChinese ? '選擇範圍' : 'Select Area';
        areaSelect.innerHTML = '<option value="">' + selectAreaText + '</option>';
        
        customContainer.appendChild(districtSelect);
        customContainer.appendChild(expressCheckboxWrapper);
        customContainer.appendChild(expressHint);
        customContainer.appendChild(areaSelect);

        refreshExpressEligibilityUi();
        applySavedZapietSelection();

        // Insert our new container before Zapiet's wrapper so it uses normal flow layout
        wrapper.parentElement.insertBefore(customContainer, wrapper);
        
        districtSelect.addEventListener('change', function() {
          var selectedDistrict = getTrimmedString(districtSelect.value);

          resetZapietWidget();
          expressCheckbox.checked = false;
          expressEnabled = false;
          refreshExpressEligibilityUi();

          persistCustomZapietSelection({
            district: selectedDistrict,
            deliveryArea: selectedDistrict,
            area: '',
            areaCode: '',
            areaKey: normalizeDeliveryArea(selectedDistrict),
          });
        });

        // Robust trigger helper to push value into Zapiet's framework
        function triggerZapietCheck(inputNode, valueToSet) {
            // Re-fetch the live input in case Zapiet replaced it in the DOM
            var liveApp = document.querySelector('#storePickupApp') || document.querySelector('.zapiet-widget-wrapper');
            var liveInput = (liveApp && liveApp.querySelector('input[type="text"]')) || inputNode;

            if(!liveInput) return;

            liveInput.focus();
            
            var prototype = Object.getPrototypeOf(liveInput);
            var prototypeValueSetter = prototype ? Object.getOwnPropertyDescriptor(prototype, 'value') : null;
            var valueSetter = Object.getOwnPropertyDescriptor(liveInput, 'value');
            
            if (prototypeValueSetter && prototypeValueSetter.set && valueSetter && valueSetter.set !== prototypeValueSetter.set) {
                prototypeValueSetter.set.call(liveInput, valueToSet);
            } else if (valueSetter && valueSetter.set) {
                valueSetter.set.call(liveInput, valueToSet);
            } else {
                liveInput.value = valueToSet;
            }

            liveInput.dispatchEvent(new Event('input', { bubbles: true }));
            liveInput.dispatchEvent(new Event('change', { bubbles: true }));
            
            setTimeout(function() {
                var btn = liveInput.parentElement.querySelector('button') || liveInput.nextElementSibling;
                if (btn && typeof btn.click === 'function') {
                    btn.click();
                } else {
                    // Try to click an SVG or wrapper if the button isn't a strict 'button' element
                    var alternateBtn = liveInput.parentElement.querySelector('.zapiet-delivery-validator__btn, [role="button"]');
                    if(alternateBtn && typeof alternateBtn.click === 'function') {
                        alternateBtn.click();
                    }
                }

                ['keydown', 'keypress', 'keyup'].forEach(function(eventType) {
                    liveInput.dispatchEvent(new KeyboardEvent(eventType, {
                        key: 'Enter',
                        code: 'Enter',
                        keyCode: 13,
                        which: 13,
                        bubbles: true,
                        cancelable: true
                    }));
                });
                
                liveInput.blur();
            }, 150);
        }
        
        areaSelect.addEventListener('change', function() {
          var selectedCode = areaSelect.value;
          var selectedDistrict = getTrimmedString(districtSelect.value);
          var nextState = {
            district: selectedDistrict,
            deliveryArea: selectedDistrict,
            area: getSelectedAreaLabel(),
            areaCode: selectedCode,
            areaKey: normalizeDeliveryArea(selectedDistrict),
          };

          persistCustomZapietSelection(nextState);

          if(selectedCode) {
            triggerZapietCheck(zapietInput, selectedCode);
          }
        });
      }
    }); // end MutationObserver callback
    
    zapietObserver.observe(document.body, { childList: true, subtree: true });
  }

  // --- CUSTOM ZAPIET PICKUP LOCATION FILTER ---
  // NOTE: intentionally has no shared functions/state with initZapietDistrictDropdowns above; the
  // Store Pickup panel has no search input to redirect, so this filters the rendered .location cards.
  // NOTE: only ever (a) append into the static "Please select a pickup location:" wrapper - a fixed,
  // single-purpose node Zapiet never re-renders once mounted, same category as how the delivery hack
  // above appends next to its input's wrapper - and (b) set style.display on existing leaf elements.
  // Never insert a sibling into the dynamically-growing ZapietStack list itself; that corrupted
  // Preact's own reconciliation and silently broke the date/time picker in an earlier attempt.
  function initZapietPickupLocationFilter() {
    if (!window.HK_DISTRICT_DATA) return;

    var pickupObserver = new MutationObserver(function () {
      var pickupPanel = document.querySelector('#storePickupApp .checkoutMethodContainer.pickup');
      if (!pickupPanel) return;

      var locationsList = pickupPanel.querySelector('.locations');
      if (!locationsList || locationsList.hasAttribute('data-pickup-filter-injected')) return;

      var cards = Array.prototype.slice.call(locationsList.querySelectorAll('.location'));
      if (!cards.length) return;

      var introText = pickupPanel.querySelector('.ZapietStack-Item--fullWidth');
      if (!introText) return;

      locationsList.setAttribute('data-pickup-filter-injected', 'true');

      var isChinese = window.HK_DISTRICT_LANG && window.HK_DISTRICT_LANG.indexOf('zh') === 0;
      var selectRegionText = isChinese ? '選擇地區' : 'Select Region';
      var selectDistrictText = isChinese ? '選擇分區' : 'Select District';
      var selectHintText = isChinese
        ? '請選擇地區及分區以查看可用的自取地點。'
        : 'Select a region and district above to see available pickup locations.';
      var regionTranslations = {
        'Hong Kong Island': '香港島',
        'Kowloon': '九龍',
        'New Territories': '新界',
        'Outlying Islands': '大嶼山南及離島',
      };

      // Location city comes from Zapiet's pickup_address_format, always nested as
      // <span class="address">line1<br><span class="address">line2<br>{{city}}</span></span>.
      function extractCity(card) {
        var innerAddress = card.querySelector('.address .address');
        if (!innerAddress) return '';
        var parts = (innerAddress.innerHTML || '').split(/<br\s*\/?>/i);
        var wrapper = document.createElement('span');
        wrapper.innerHTML = parts[parts.length - 1] || '';
        return getTrimmedString(wrapper.textContent);
      }

      function findRegionForCity(city) {
        var normalizedCity = getTrimmedString(city).toLowerCase();
        if (!normalizedCity) return '';

        var regions = Object.keys(window.HK_DISTRICT_DATA);
        for (var i = 0; i < regions.length; i += 1) {
          var areas = window.HK_DISTRICT_DATA[regions[i]];
          for (var j = 0; j < areas.length; j += 1) {
            if (getTrimmedString(areas[j].english).toLowerCase() === normalizedCity) {
              return regions[i];
            }
          }
        }

        return '';
      }

      // Zapiet's admin suffixes every SF Express locker location name with "[SF Express]";
      // any card without it is one of our own Steak King stores.
      var entries = cards.map(function (card) {
        var city = extractCity(card);
        return {
          el: card,
          radio: card.querySelector('input[type="radio"].locationRadio'),
          city: city,
          region: findRegionForCity(city),
          type: card.textContent.indexOf('[SF Express]') !== -1 ? 'sf' : 'store',
        };
      });

      function styleFilterSelect(select) {
        select.style.width = '100%';
        select.style.padding = '10px';
        select.style.border = '1px solid #ccc';
        select.style.borderRadius = '4px';
        select.style.backgroundColor = '#fff';
        select.style.fontSize = '16px';
        select.style.appearance = 'none';
        select.style.backgroundImage = 'url("data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%23000%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E")';
        select.style.backgroundRepeat = 'no-repeat';
        select.style.backgroundPosition = 'right 10px top 50%';
        select.style.backgroundSize = '12px auto';
      }

      var container = document.createElement('div');
      container.style.width = '100%';
      container.style.marginTop = '10px';
      container.style.marginBottom = '14px';

      var regionSelect = document.createElement('select');
      regionSelect.id = 'zapiet-pickup-region-select';
      styleFilterSelect(regionSelect);
      regionSelect.innerHTML = '<option value="">' + selectRegionText + '</option>';

      var districtSelect = document.createElement('select');
      districtSelect.id = 'zapiet-pickup-district-select';
      styleFilterSelect(districtSelect);
      districtSelect.style.display = 'none';
      districtSelect.style.marginTop = '10px';
      districtSelect.innerHTML = '<option value="">' + selectDistrictText + '</option>';

      var hint = document.createElement('p');
      hint.id = 'zapiet-pickup-filter-hint';
      hint.textContent = selectHintText;
      hint.style.marginTop = '10px';
      hint.style.fontSize = '14px';
      hint.style.color = '#725400';

      function rebuildDistrictOptions(selectedRegion) {
        districtSelect.innerHTML = '<option value="">' + selectDistrictText + '</option>';
        if (!selectedRegion) return;

        var cities = [];
        entries.forEach(function (entry) {
          if (entry.type !== 'sf') return;
          if (entry.region === selectedRegion && entry.city && cities.indexOf(entry.city) === -1) {
            cities.push(entry.city);
          }
        });

        cities.sort(function (a, b) {
          return a.localeCompare(b);
        });

        cities.forEach(function (city) {
          var option = document.createElement('option');
          option.value = city;
          option.innerText = city;
          districtSelect.appendChild(option);
        });
      }

      // Show the date/time picker only while a currently-VISIBLE location card is checked - covers
      // both a real user click and Zapiet's own default preselection (which sets .checked without
      // firing a 'change' event we'd otherwise catch). Re-evaluated whenever Zapiet mutates its own
      // subtree, since the wrapper node may not exist yet at the moment a filter first runs.
      function hasVisibleCheckedLocation() {
        return entries.some(function (entry) {
          return entry.radio && entry.radio.checked && entry.el.style.display !== 'none';
        });
      }

      // Zapiet swaps the date/time field between an expanded input (.Zapiet-InputWithPrefix__Wrapper)
      // and a compact selected-value pill (.Zapiet-Select__Wrapper) - only one is visible at a time
      // and toggling either one directly is unreliable. Both live inside the same outer
      // .ZapietStack-Item that Zapiet renders once as a direct child of the .ZapietStack--vertical
      // list, so hide that instead - a single existing leaf node, safe to toggle in place.
      function closestVerticalStackItem(node) {
        while (node) {
          if (
            node.classList &&
            node.classList.contains('ZapietStack-Item') &&
            node.parentElement &&
            node.parentElement.classList.contains('ZapietStack--vertical')
          ) {
            return node;
          }
          node = node.parentElement;
        }
        return null;
      }

      function syncPickupDateWrapperVisibility() {
        var visible = hasVisibleCheckedLocation();
        var markers = pickupPanel.querySelectorAll('.Zapiet-Select__Wrapper, .Zapiet-InputWithPrefix__Wrapper');
        var handled = [];
        for (var i = 0; i < markers.length; i += 1) {
          var stackItem = closestVerticalStackItem(markers[i]);
          if (stackItem && handled.indexOf(stackItem) === -1) {
            handled.push(stackItem);
            stackItem.style.display = visible ? '' : 'none';
          }
        }
      }

      new MutationObserver(syncPickupDateWrapperVisibility).observe(pickupPanel, { childList: true, subtree: true });

      // Store cards are always excluded here - this filter only ever governs the SF Pickup side.
      function applyFilter(selectedRegion, selectedDistrict) {
        var ready = !!selectedRegion && !!selectedDistrict;

        entries.forEach(function (entry) {
          if (entry.type !== 'sf') {
            entry.el.style.display = 'none';
            return;
          }
          var matches = ready && entry.city === selectedDistrict;
          entry.el.style.display = matches ? '' : 'none';
        });

        locationsList.style.display = ready ? '' : 'none';
        hint.style.display = ready ? 'none' : 'block';
        syncPickupDateWrapperVisibility();
      }

      locationsList.addEventListener('change', function (event) {
        if (event.target && event.target.matches('input.locationRadio')) {
          syncPickupDateWrapperVisibility();
        }
      });

      regionSelect.addEventListener('change', function () {
        var selectedRegion = regionSelect.value;
        rebuildDistrictOptions(selectedRegion);
        districtSelect.style.display = selectedRegion ? 'block' : 'none';
        districtSelect.value = '';
        applyFilter(selectedRegion, '');
      });

      districtSelect.addEventListener('change', function () {
        applyFilter(regionSelect.value, districtSelect.value);
      });

      // Only offer regions that actually have at least one SF Pickup location right now.
      var availableRegions = [];
      entries.forEach(function (entry) {
        if (entry.type === 'sf' && entry.region && availableRegions.indexOf(entry.region) === -1) {
          availableRegions.push(entry.region);
        }
      });

      Object.keys(window.HK_DISTRICT_DATA).forEach(function (region) {
        if (availableRegions.indexOf(region) === -1) return;
        var option = document.createElement('option');
        option.value = region;
        option.innerText = (isChinese && regionTranslations[region]) ? regionTranslations[region] : region;
        regionSelect.appendChild(option);
      });

      container.appendChild(regionSelect);
      container.appendChild(districtSelect);
      container.appendChild(hint);

      // --- Store / SF Pickup mode toggle ---
      var toggleStoreText = isChinese ? '門市自取' : 'Store Pickup';
      var toggleSfText = isChinese ? 'SF 自取' : 'SF Pickup';

      var modeToggle = document.createElement('div');
      modeToggle.id = 'zapiet-pickup-mode-toggle';
      modeToggle.className = 'sk-pickup-mode-toggle';

      var modeIndicator = document.createElement('span');
      modeIndicator.className = 'sk-pickup-mode-toggle__indicator';

      var storeToggleBtn = document.createElement('button');
      storeToggleBtn.type = 'button';
      storeToggleBtn.className = 'sk-pickup-mode-toggle__option';
      storeToggleBtn.textContent = toggleStoreText;

      var sfToggleBtn = document.createElement('button');
      sfToggleBtn.type = 'button';
      sfToggleBtn.className = 'sk-pickup-mode-toggle__option';
      sfToggleBtn.textContent = toggleSfText;

      modeToggle.appendChild(modeIndicator);
      modeToggle.appendChild(storeToggleBtn);
      modeToggle.appendChild(sfToggleBtn);

      function setToggleButtonState(button, active) {
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      }

      function applyPickupMode(mode) {
        setToggleButtonState(storeToggleBtn, mode === 'store');
        setToggleButtonState(sfToggleBtn, mode === 'sf');
        modeToggle.classList.toggle('sk-pickup-mode-toggle--sf', mode === 'sf');

        if (mode === 'store') {
          container.style.display = 'none';
          entries.forEach(function (entry) {
            entry.el.style.display = entry.type === 'store' ? '' : 'none';
          });
          locationsList.style.display = '';
          syncPickupDateWrapperVisibility();
          return;
        }

        // Always reset so switching back into SF Pickup never shows a stale filter from a previous visit.
        container.style.display = 'block';
        regionSelect.value = '';
        districtSelect.value = '';
        districtSelect.style.display = 'none';
        applyFilter('', '');
      }

      storeToggleBtn.addEventListener('click', function () {
        applyPickupMode('store');
      });

      sfToggleBtn.addEventListener('click', function () {
        applyPickupMode('sf');
      });

      introText.insertBefore(modeToggle, introText.firstChild);
      introText.appendChild(container);

      applyPickupMode('store');
    });

    pickupObserver.observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initZapietDistrictDropdowns();
    initZapietPickupLocationFilter();
  });
})();
